import type { Organization } from "@/types/organization";
import type { User, UserUpdateData } from "@/types/user";
import { ApiClientError, fetchJson } from "@/services/api-client";

export async function getOrganizations(
  organizationIds: string[],
): Promise<Organization[]> {
  const { organizations } = await fetchJson<{
    organizations?: Organization[];
  }>(
    "/api/organizations",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ids: organizationIds }),
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to fetch organizations." },
  );

  return organizations || [];
}

export async function getUser(forceRefresh = false): Promise<User> {
  const url = forceRefresh ? `/api/user?_=${Date.now()}` : `/api/user`;

  try {
    const data = await fetchJson<{ user?: User }>(
      url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        cache: "no-store",
      },
      { fallbackErrorMessage: "Failed to fetch user." },
    );

    return data.user || null;
  } catch (error) {
    if (
      error instanceof ApiClientError &&
      (error.status === 401 || error.status === 404)
    ) {
      return null;
    }

    throw error;
  }
}

export async function updateUser(userData: UserUpdateData): Promise<User> {
  const data = await fetchJson<{ user?: User }>(
    "/api/user",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    },
    { fallbackErrorMessage: "Failed to update user data." },
  );

  return data.user || null;
}
